Apt.fn.make('search.results', {
	/**
	 * Initialize module
	 */
	init: function() {
		// Initialize the main search module which handles both header and full page results
		Apt.search.init();

		// Bind wishlist functionality for the results
		Apt.wishlists.bind('results', 'ref:search-results');
	},

	/**
	 * Unload module
	 */
	unload: function() {
		// Clean up wishlist events
		$.events.reset('results');
		
		// Clean up search module
		if (Apt.search.unload) {
			Apt.search.unload();
		}
	}
});
